import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => {
  return {
    popupItem: {
      ' .ant-select-item-option-grouped': {
        '.ant-select-item-option-content': {
          display: 'flex',
          justifyContent: 'space-between',

          ' .ant-flex': {
            width: '100%',
            justifyContent: 'end'
          }
        },

        paddingInline: token.paddingSM
      }
    }
  }
})
